<template>
  <div class="vListsCon">
    <div
      v-for="item in CoursewareList"
      :key="item.index"
    >
      <!-- vType:0--不记时视频 1--要计时视频 -->
      <router-link :to="{path:'/videoD',query:{vObj:JSON.stringify(item),vType:1,year:StudyMonth,folderId:folderId}}">
        <div class="videoItems clearfix">
          <div class="weiVImgBox fl">
            <img
              :src="path + item.image_path"
              alt=""
              class="weiVImg"
              :onerror="defaultImg"
            />
            <img
              src="../assets/imgs/playIcon.png"
              alt=""
              class="toPlay"
            />
            <img
              v-if="item.study_type==0"
              src="../assets/imgs/biStudy.png"
              alt=""
              class="videoType"
            >
            <img
              v-else
              src="../assets/imgs/xuanStudy.png"
              alt=""
              class="videoType"
            >
            <span>{{item.dataduration}}</span>
          </div>
          <div class="fr">
            <p class="vTit">{{item.title}}</p>
            <p
              class="vInfo"
              style=" display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2;"
            >{{item.description | substringdiscrib}}</p>
            <dl class="vProgress">
              <dd v-if="item.play_point === 0 || item.play_point === null">未学习</dd>
              <dd
                v-else-if="item.played_progress === '100%'"
                style="color:#6DA0F3"
              >已学习</dd>
              <dd v-else>{{item.played_progress}}</dd>
              <!-- 收藏 -->
              <!-- <dd><img
                src="../assets/imgs/shoucang.png"
                alt=""
                class="scImg"
              ></dd> -->
            </dl>
          </div>
        </div>
      </router-link>
    </div>
    <div
      v-show="isHasdata"
      class="noData"
    >
      <img
        src="../assets/imgs/noDataIcon.png"
        alt=""
      >
      <p class="noDataTit">未查询到相关数据</p>
      <p>暂无数据，请刷新重试</p>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import { getStudyMonthToCourseware } from '../../src/api/Api'
export default {
  name: 'vListsCon',
  data () {
    return {
      isHasdata: false, // 有无数据
      StudyMonth: '', // 当前学年
      userId: sessionStorage.getItem('userId'),
      CompanyId: sessionStorage.getItem('companyId'),
      ProfessionId: sessionStorage.getItem('professionId'),
      CoursewareList: [], // 课程列表
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      path: window.baseapi.baseUrl,
      folderId: ''
    }
  },
  created () {
    this.StudyMonth = this.$route.query.year
    this.folderId = this.$route.query.folderId
    this.getStudyMonthToCoursewares()
  },
  mounted () {
    window.myVue = this
  },
  destroyed () {
    Indicator.close()
  },
  methods: {
    getStudyMonthToCoursewares () {
      Indicator.open()
      var _this = this
      if(_this.ProfessionId==4){
        _this.StudyMonth = "";
      }
      getStudyMonthToCourseware({
        studyMonth: _this.StudyMonth,
        employeeId: _this.userId,
        companyId: _this.CompanyId,
        professionId: _this.ProfessionId,
        folderId: _this.folderId
      }).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.isHasdata = false
          Indicator.close()
          _this.CoursewareList = res.data.data
          if (res.data.data.length < 1) {
            this.isHasdata = true
          }
        } else {
          Indicator.close()
          // Toast(res.data.returnMsg)
          this.isHasdata = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/VideoLists.vue